import { serviceActionsGenerator } from '../serviceGenerator'

const actionTypes = ['!UPDATE_LIST_SELECT', '!SET_LAST_VISITED_SUB_PAGE', '!DETAILS_PAGING_CONFIG_UPDATE'] as const

export default serviceActionsGenerator('controls', actionTypes)
